export default __webpack_public_path__ + "static/media/collaborator.bf40c245.jpg";